export const aiEmployeePromoRoutes = {
    default:'ai_employee_promo',
    main: 'ai-employee-promo-main',
  }

export const aiAgentsContestRoutes = {
    default: 'ai_agents_contest',
    main: 'ai-agents-contest-main',
  }
  